<template>
  <div class="ignore-news-item" @click="goNews">
    <img class="news-img" :src="cover" alt="新闻图片">
    <div class="right">
      <div class="title">{{title}}</div>
      <div class="tag-date">
        <div class="tag">{{tag}}</div>
        <div class="date">{{dateOnly}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {},
    tag: {},
    date: {},
    cover: {},
    url: {}
  },
  computed: {
    dateOnly () {
      return this.date.split(' ')[0];
    }
  },
  methods: {
    goNews () {
      window.open(this.url);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/mixin.scss";

.ignore-news-item {
  display: flex;
  border: 1px solid #F0DC28;
  cursor: pointer;

  .news-img {
    flex: none;
    width: 163px;
    height: 120px;
    background-color: #aaaaaa;
    margin: -1px;
  }

  .right {
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .title {
      font-size: 19px;
    }

    .tag-date {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 140px;

      .tag {
        position: relative;
        font-size: 12px;
        color: #F0DC28;
        padding: 4px;

        &::after {
          @include skew-bg;
          background-color: #000;
        }
      }

      .date {
        font-size: 12px;
      }
    }
  }
}
</style>
